





















































import {
  defineComponent, reactive, toRefs, watch,
} from '@vue/composition-api'

import ModalDialog from '@/components/appBase/ModalDialog.vue'
import ApiError from '@/components/appBase/errors/ApiError.vue'
import useApiErrorViewHandler from '@/components/appBase/errors/useApiErrorViewHandler'
import useClientflowApi from '@/api/clientFlow/useClientflowApi'

const initialState: {
  showMe: boolean;
  confirmChecked: boolean;
  formIsValid: boolean;
} = {
  showMe: true,
  confirmChecked: false,
  formIsValid: false,
}

export default defineComponent({
  name: 'DeleteClientModal',
  components: {
    ModalDialog, ApiError,
  },

  props: {
    show: {
      type: Boolean,
      default: true,
    },
    clientId: {
      type: String,
      required: true,
    },
    clientName: {
      type: String,
      required: true,
    },
    sessionId: {
      type: String,
      required: true,
    },
    sessionDate: {
      type: Date,
      required: true,
    },
  },

  setup(props, context) {
    const state = reactive({ ...initialState })

    function confirm(): void {
      context.emit('confirmed')
    }
    function cancel(): void {
      context.emit('cancelled')
    }

    const getFormattedDate = (date: Date) => date.toLocaleDateString(
      context.root.$vuetify.lang.current,
      {
        weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
      },
    )

    watch(
      () => props.show,
      (show) => {
        state.showMe = show
      },
    )

    watch(
      () => state.showMe,
      (show) => {
        if (!show) context.emit('cancelled')
      },
    )

    // Compose!
    // ...delegate api handling to useClientflowApi():
    const {
      ClientFlowApi,
      awaitingResponse,
      hasResponseError,
      handler,
      errorDisplay,
    } = useClientflowApi()

    // ...delegate logic around showing api error to useApiErrorViewHandler():
    const {
      errorVisibilityHasChangedTo,
      toggleShowApiError,
      showResponseError,
      showingResponseError,
    } = useApiErrorViewHandler(hasResponseError)

    async function deleteSession(clientId: string, sessionId: string) {
      const cmd = await ClientFlowApi.deleteSession({
        clientId,
        sessionId,
      })
      const response = await handler.handle(cmd)
      if (response.isOk()) {
        context.emit('session-deleted')
      }
    }

    return {
      ...toRefs(state),
      confirm,
      cancel,
      deleteSession,
      getFormattedDate,

      // from use ClienFlowApi
      hasResponseError,
      awaitingResponse,
      errorDisplay,

      // from useApiErrorViewHandler
      showingResponseError,
      showResponseError,
      toggleShowApiError,
      errorVisibilityHasChangedTo,
    }
  },

})

